import React from "react";
import { Megaphone, BellSimpleRinging } from "phosphor-react";

// Helper: parse a single stored "body" into {title, body}
// - Title = first paragraph (split by blank line). If there are no blank lines,
//   we fall back to first line up to the first newline.
// - Body  = remainder after the title paragraph.
function parseStoredBody(stored) {
  const raw = (stored || "").replace(/\r\n/g, "\n").trim();
  if (!raw) return { title: "", body: "" };

  // Prefer blank-line split (paragraphs)
  const paraParts = raw.split(/\n\s*\n/);
  if (paraParts.length > 1) {
    const title = paraParts[0].trim();
    const rest = paraParts.slice(1).join("\n\n").trim();
    return { title, body: rest };
  }

  // Fallback: first line as title
  const nl = raw.indexOf("\n");
  if (nl >= 0) {
    return { title: raw.slice(0, nl).trim(), body: raw.slice(nl + 1).trim() };
  }
  return { title: raw, body: "" };
}

export default function AnnouncementsBanner({ announcement, isAdmin, onCreate, onViewAll }) {
  const parsed = parseStoredBody(announcement?.body);
  const displayTitle = parsed.title || "Announcement";
  const displayBody = parsed.body;

  return (
    <div className="relative bg-white rounded-2xl p-5 pt-3 pb-3">
      {/* Floating pill */}
      <div className="absolute -top-3 left-5">
        <span className="inline-flex items-center gap-1.5 bg-blue-600 text-white text-sm px-3 py-1 rounded-full shadow-sm">
          <Megaphone size={14} weight="fill" className="text-white" />
          Announcements
        </span>
      </div>

      {/* Header buttons */}
      <div className="flex items-center justify-end mt-1">
        <div className="flex gap-1.5">
          {typeof onViewAll === "function" && (
            <button
              type="button"
              onClick={onViewAll}
              className="inline-flex items-center justify-center text-sm rounded-full bg-blue-100 text-blue-700 hover:ring-2 hover:ring-blue-200 
                         overflow-hidden leading-none [min-width:0] [min-height:0] !px-3 !py-1 !h-6 transition-colors"
              style={{ lineHeight: 1 }}
            >
              View all
            </button>
          )}
          {isAdmin && typeof onCreate === "function" && (
            <button
              type="button"
              onClick={onCreate}
              className="inline-flex items-center justify-center text-sm rounded-full bg-yellow-200 text-black hover:ring-2 hover:ring-yellow-300 
                         overflow-hidden leading-none [min-width:0] [min-height:0] !px-3 !py-1 !h-6 transition-colors"
              style={{ lineHeight: 1 }}
            >
              Create
            </button>
          )}
        </div>
      </div>

      {/* Announcement content */}
      {announcement ? (
        <div className="mt-0">
          <div className="text-lg md:text-[15px] font-semibold leading-snug break-words text-gray-900">
            {displayTitle}
          </div>
          {displayBody ? (
            <div className="mt-1 text-sm text-gray-700 whitespace-pre-wrap break-words">
              {displayBody}
            </div>
          ) : null}
        </div>
      ) : (
        <p className="mt-2 text-sm text-gray-600">No announcements yet.</p>
      )}
    </div>
  );
}
